import Address from "../../Inputs/Address";

export default function Location({user, onChange, show}){

    return show && <>

        <Address 
            value={user}
            onChange={user => onChange(user)}
            required
        />

    </>
}